const FilePicker = require('./FilePicker');
const GlobalAlerts = require('./GlobalAlerts');
const dialog = require('../templates/conciliacao-despesas.html');
const Lang = require('lang');

const buttonConciliation = document.getElementById('send-conciliation-confirmation');

function ConciliarDespesas() {
  const checkItems = document.querySelectorAll('[data-conciliation-value]');
  const headCheck = document.querySelectorAll('[data-conciliation-head]');

  nifty.body.overlay({
    fixed: true
  })

  if (buttonConciliation) {
    buttonConciliation.addEventListener('click', confirmarConciliacao);
  }
}

function confirmarConciliacao(event) {
  const form = event.target.form;
  const buttonConfirm = event.target;
  const checkedItems = form.querySelectorAll('[data-conciliation-value]:checked');

  if (checkedItems.length) {
    confirmationDialog(checkedItems, buttonConfirm);
  } else {
    emptyAlert();
  }
}

function emptyAlert() {
  bootbox.alert({
    title: Lang.get('js/common/words.ops'),
    message: Lang.get('js/src/functions/conciliarDespesas.no_expenses_was_selected'),
    size: 'small'
  });
}

function confirmationDialog(checkedItems, buttonConfirm) {
  buttonConfirm.disabled = true;

  const confirmation = bootbox.dialog({
    title: Lang.get('js/src/functions/conciliarDespesas.conciliation_confirmation'),
    message: dialog,
    buttons: {
      cancel: {
        label: Lang.get('js/common/words.cancel'),
        className: 'btn-danger',
        callback: function () {
          buttonConfirm.disabled = false;
        }
      },
      confirm: {
        label: Lang.get('js/common/words.confirm'),
        className: 'btn-success',
        callback: function sendForm(event) {
          nifty.body.overlay('show');
          const dataConciliacaoInput = this.find('#dataConciliacao').get(0);
          event.target.disabled = true;
          if (!/^\d{2}\/\d{2}\/\d{4}$/.test(dataConciliacaoInput.value)) {
            GlobalAlerts.createAndShow({
              title: Lang.get('js/common/words.ops'),
              message: Lang.get('js/src/functions/conciliarDespesas.invalid_date_format'),
              type: 'danger'
            });

            buttonConfirm.disabled = false;
            event.target.disabled = false;

            return false;
          }
          const formModal = document.querySelector('#form-conciliation-modal');
          const object = new FormData(formModal);

          const itens = [];
          checkedItems.forEach((item) => {
            object.append('itens[]', item.value);
          });

          sendRequest(object)
            .done(function (data) {
              GlobalAlerts.createAndShow({
                title: Lang.get('js/src/functions/AlterarConciliacao.success'),
                message: data.message,
              });
              $('#default-filter-data').trigger('click');
            })
            .fail(function (error) {
              GlobalAlerts.createAndShow({
                type: 'danger',
                title: Lang.get('js/src/functions/AlterarConciliacao.ops'),
                message: error.responseJSON.message,
              });
            })
            .always(function () {
              nifty.body.overlay('hide');
              buttonConfirm.disabled = false;
              event.target.disabled = false;
            });

          return false;
        }
      }
    }
  });

  confirmation.on('shown.bs.modal', function () {
    FilePicker.init();
    const input = $(this).find('#dataConciliacao');

    translateLabelsForm($(this));
    input.datepicker();
    input.datepicker('setDate', 'now');
  });

  confirmation.on('hidden.bs.modal', function () {
    buttonConfirm.disabled = false;
  });
}

/**
 * Completar a label das taxas com a iso da moeda padrao
 * da empresa
 *
 * @param  element buttonConciliation [description]
 */
function translateLabelsForm(form) {
  const currencyDefault = buttonConciliation.getAttribute('data-currency-default');

  const descricao = form.find('#labelDescricao').get(0);
  const dataConciliacao = form.find('#labelDataConciliacao').get(0);
  const iof = form.find('#labelIof').get(0);
  const variacaoCambial = form.find('#labelVariacaoCambial').get(0);
  // File Picker
  const filePickerTitle = form.find('#file-picker-title').get(0);
  const filePickerImage = form.find('#file-picker-image').get(0);
  const filePickerPdf = form.find('#file-picker-pdf').get(0);
  const filePickerRemove = form.find('#file-picker-remove').get(0);

  descricao.innerHTML = Lang.get('js/src/app/admin/conciliacoes/index.description');
  dataConciliacao.innerHTML = Lang.get('js/src/app/admin/conciliacoes/index.conciliation_date');
  iof.innerHTML = Lang.get('js/src/app/admin/conciliacoes/index.rate_iof', { isoMoedaPadrao: currencyDefault });
  variacaoCambial.innerHTML = Lang.get('js/src/app/admin/conciliacoes/index.rate_exchange_variation', { isoMoedaPadrao: currencyDefault });

  // File Picker
  filePickerTitle.innerHTML = Lang.get('js/src/app/admin/conciliacoes/index.file_picker_title')
  filePickerImage.innerHTML = Lang.get('js/src/app/admin/conciliacoes/index.file_picker_image')
  filePickerPdf.innerHTML = Lang.get('js/src/app/admin/conciliacoes/index.file_picker_pdf')
  filePickerRemove.innerHTML = Lang.get('js/src/app/admin/conciliacoes/index.file_picker_remove')
}

function sendRequest(data) {
  return $.ajax({
    url: route('app.admin.conciliacoes.confirmar-conciliacao'),
    method: 'POST',
    data: data,
    contentType: false,
    processData: false
  });
}

module.exports = {
  init: ConciliarDespesas,
  url: '/admin/conciliacoes'
};
